import React, { useRef, useEffect } from 'react';
import { Box } from '@material-ui/core';
import * as echarts from 'echarts';
import { fmtThousand } from '@/utils/comUtil';

export default ({ height, data = [] }) => {
  const pieOneRef = useRef(null);
  useEffect(() => {
    const myChart = echarts.init(pieOneRef?.current);
    const option = {
      tooltip: {
        trigger: 'item',
        position: ['70%', '70%'],
        formatter: function (p) {
          return `${p.data.name}</br>${fmtThousand(p.data.value.toFixed(0))}`;
        },
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['80%', '100%'],
          hoverAnimation: false,
          minAngle: 30,
          itemStyle: {
            borderRadius: 10,
            borderWidth: 2,
            normal: {
              color: (params) => {
                const color = ['#017AFF', '#E9F0F7'];
                return color[params.dataIndex];
              },
            },
          },
          label: {
            normal: {
              show: true,
              position: 'center',
              color: '#4c4a4a',
              formatter: () => {
                return data.length > 0
                  ? `${(data[0].percent * 100).toFixed(2)}%`
                  : null;
              },
              rich: {
                total: {
                  fontSize: 35,
                  color: '#454c5c',
                },
                active: {
                  fontSize: 16,
                  color: '#6c7a89',
                  lineHeight: 30,
                },
              },
            },
            emphasis: {
              //中间文字显示
              show: true,
            },
          },
          labelLine: {
            length: 0,
            length2: 10,
          },
          data: data,
        },
      ],
    };

    option && myChart.setOption(option);
    myChart.resize();
    window.addEventListener(
      'resize',
      function () {
        myChart.resize();
      },
      false,
    );
    return () => {
      window.removeEventListener('resize', function () {
        myChart.resize();
      });
    };
  }, [data]);
  return <Box ref={pieOneRef} sx={{ width: '100%', height: height }}></Box>;
};
